import { css } from "../../../../../styled-system/css";
import { t } from "../../../../libs/i18n";
import { Heading } from "./heading";

export const TagajoCampaignDetail = () => {
  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      })}
    >
      <Heading>{t("ポイント付与について")}</Heading>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
        })}
      >
        {t("現時点で多賀城市に住民登録がある方に、3,000ポイントを付与します。")}
        <br />
        <br />
        {t(
          "応募するとただちにポイントが付与され、令和8年10月31日までの期間、対象店舗で1ポイント=1円として利用できます。",
        )}
      </p>

      <Heading>{t("スケジュール")}</Heading>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
        })}
      >
        {t("■ポイント付与期間")}
        <br />
        {t("令和8年2月3日から令和8年4月30日まで")}
      </p>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
          mt: "12px",
        })}
      >
        {t("■ポイント利用期限")}
        <br />
        {t("令和8年10月31日（11月1日となった時点でポイントが失効します）")}
      </p>
    </div>
  );
};
